// extracted by mini-css-extract-plugin
export default {"root":"SuccessMessageModal_root__MI9UI","doneIcon":"SuccessMessageModal_doneIcon__CdSRV"};